import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { MuscleMap } from '@/components/exercises/Exercise/Muscles/MuscleMap/MuscleMap'
import { Section } from '@/components/exercises/Exercise/Section/Section'
import { type ExerciseItem, getMusclesWorked } from '@/utils/exercises'

import { MuscleList } from './MuscleList/MuscleList'
import {
  StyledDiagramWrapper,
  StyledMuscleLayout,
  StyledMuscleLists,
} from './Muscles.Styled'

type Props = {
  exercise: ExerciseItem
}

export const Muscles = ({ exercise }: Props) => {
  const { t } = useTranslation()

  const { musclesWorked, musclesStretched } = useMemo(() => {
    return {
      musclesWorked: getMusclesWorked(exercise.muscle_intensity),
      musclesStretched: getMusclesWorked(exercise.muscle_intensity_stretch),
    }
  }, [exercise.muscle_intensity, exercise.muscle_intensity_stretch])

  if (!musclesWorked.length && !musclesStretched.length) {
    return null
  }

  return (
    <Section title={t('landing_exercises_muscle_map')}>
      <StyledMuscleLayout>
        <StyledDiagramWrapper>
          <MuscleMap
            intensity={exercise.muscle_intensity}
            intensityStretch={exercise.muscle_intensity_stretch}
          />
        </StyledDiagramWrapper>

        <StyledMuscleLists>
          <MuscleList
            label={t('landing_exercises_muscles_worked')}
            muscles={musclesWorked}
            variant="orange"
          />
          <MuscleList
            label={t('landing_exercises_muscles_stretched')}
            muscles={musclesStretched}
            variant="blue"
          />
        </StyledMuscleLists>
      </StyledMuscleLayout>
    </Section>
  )
}
